"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const cardResources_1 = require("../common/cardResources");
exports.default = (0, vue_1.defineComponent)({
    name: 'CardResourceCounter',
    props: {
        amount: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        cssClass() {
            return cardResources_1.cardResourceCSS[this.type];
        },
    },
});
